import React, { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { taxRateService } from "../../Services/taxRate.service";
import CardWrap from "../Common/CardWrap";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import {
  lettersAndNumbers,
  lettersOnly,
  numbersOnly,
} from "../../Config/Regex";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import Tooltip from "../Common/Tooltip";

export default function TaxRateAdd() {
  const { t: translator } = useTranslation();
  const { roleId } = useContext(AuthContext);
  const { master, admin } = roles;
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const history = useHistory();

  useEffect(() => {
    if (![master, admin].includes(Number(roleId)))
      history.push("/error-page/401");
  }, []);

  const initialState = {
    name: "",
    value: "",
  };

  const [taxRate, setTaxRate] = useState(initialState);
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const goBack = () => {
    history.push("/tax-rates");
  };

  const handleClose = () => {
    setModal({ show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  const onSubmit = (data) => {
    taxRateService
      .create({
        name: data.name,
        value: Number(data.value),
      })
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("TaxRate-Add-SuccesModal-Title"),
              text: translator("TaxRate-Add-SuccesModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("TaxRate-Add-UnsuccesModal-Title"),
              text: translator("TaxRate-Add-UnsuccesModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("TaxRate-Add-UnsuccesModal-Title"),
          text: translator("TaxRate-Add-UnsuccesModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };

  const handleCancel = () => {
    history.push("/tax-rates");
  };

  return (
    <CardWrap
      subtitle={translator("TaxRates-Create-Subtitle-NewTaxRate")}
      backUrl={"/tax-rates"}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("TaxRates-Create-Personal-Data")}
            </legend>
            <div className="form-group">
              <label>{translator("TaxRates-Create-Name-TaxRate")}</label>{" "}
              <Tooltip text={translator("TaxRate-Name-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: true,
                  maxLength: 20,
                  pattern: lettersAndNumbers,
                })}
                name="name"
              />
              {errors.name && errors.name.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.name && errors.name.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength20")}
                </p>
              )}
              {errors.name && errors.name.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-LettersAndNumbers")}
                </p>
              )}
            </div>

            <div className="form-group">
              <label>{translator("TaxRates-Create-Value-TaxRate")}</label>{" "}
              <Tooltip text={translator("TaxRate-Value-Msg")} />
              <input
                type="number"
                className="form-control"
                ref={register({ required: true, pattern: numbersOnly })}
                name="value"
              />
              {errors.value && errors.value.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.value && errors.value.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-NumbersOnly")}
                </p>
              )}
            </div>
          </fieldset>
        </div>

        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
}
